export default __webpack_public_path__ + "static/media/zhongxinjiantou.82cc199f.png";